import { Button, InputLabel, Spacer } from '@sparemin/blockhead';
import React, { useCallback, useMemo, useState } from 'react';
import { useEditSceneModalSlotsOverlayContext } from '../EditSceneModalSlotsOverlayContext';
import { useEditSceneModalZoomContext } from '../EditSceneModalZoomContext';
import {
  useCanEditSlot,
  useControlPanelMode,
  useEditSceneModalStateContext,
  useIsCropDirty,
  useIsInteractionDisabled,
} from '../state';
import useAdjustCropClickOutside from '../useAdjustCropClickOutside';
import useAdjustCropKeyBindings from '../useAdjustCropKeyBindings';
import { block } from '../utils';

const LABEL = 'Crop';

const EditSceneAdjustCropButton: React.FC = () => {
  const { isInteractionDisabled } = useIsInteractionDisabled();
  const [containerEl, setContainerEl] = useState<HTMLDivElement>(null);

  const { zoomSliderRef } = useEditSceneModalZoomContext();

  const { getOverlayRef } = useEditSceneModalSlotsOverlayContext();
  const {
    dispatch,
    state: { selectedSlotIndex },
  } = useEditSceneModalStateContext();

  const canEditSlot = useCanEditSlot();

  const isCropDirty = useIsCropDirty();

  const {
    cancelAdjustCrop,
    controlPanelMode,
    enterAdjustCrop,
  } = useControlPanelMode();

  const handleSave = useCallback(() => {
    dispatch({
      type: 'adjust-crop-commit',
    });
  }, [dispatch]);

  useAdjustCropClickOutside({
    ignoreElements: useMemo(
      () =>
        [
          containerEl,
          getOverlayRef(selectedSlotIndex)?.current,
          zoomSliderRef,
        ].filter(Boolean),
      [containerEl, getOverlayRef, selectedSlotIndex, zoomSliderRef],
    ),
    onClickOutside: handleSave,
    isDisabled: controlPanelMode !== 'adjust-crop',
  });

  useAdjustCropKeyBindings();

  // TODO blockhead should have a solution for this
  return (
    <div className={block('adjust-crop')} ref={setContainerEl}>
      <InputLabel>{LABEL}</InputLabel>
      {controlPanelMode === 'adjust-crop' ? (
        <Spacer orientation="horizontal">
          <Button
            variant="solid"
            color="tertiary"
            fluid
            onPress={cancelAdjustCrop}
            style={{ borderRadius: 6 }}
          >
            cancel
          </Button>
          <Button
            variant="solid"
            color="primary"
            fluid
            onPress={handleSave}
            isDisabled={!isCropDirty}
            style={{ borderRadius: 6 }}
          >
            save
          </Button>
        </Spacer>
      ) : (
        <Button
          variant="solid"
          color="primary"
          isDisabled={!canEditSlot || isInteractionDisabled}
          onPress={enterAdjustCrop}
          style={{ borderRadius: 6 }}
          fluid
        >
          Adjust Crop
        </Button>
      )}
    </div>
  );
};

export default EditSceneAdjustCropButton;
